export const actions = {
  FONT_SIZE_INCREMENT: "FONT_SIZE_INCREMENT",
  FONT_SIZE_DECREMENT: "FONT_SIZE_DECREMENT",
  FONT_SIZE_RECOVERY: "FONT_SIZE_RECOVERY"
};

export function increment() {
  return {
    type: actions.FONT_SIZE_INCREMENT
  };
}

export function decrement() {
  return {
    type: actions.FONT_SIZE_DECREMENT
  };
}

export function recovery() {
  return {
    type: actions.FONT_SIZE_RECOVERY
  };
}
